import React, {useEffect, useState} from 'react';

import {useAppSelector} from 'utils/hooks';
import {useTabsWithHash} from 'hooks';

import Title from 'components/title/Title';
import InnerTabs from 'components/innerTabs/InnerTabs';
import ActivationHistory from '../activationHistory/ActivationHistory';
import ProfileInfo from './assets/components/profileInfo/ProfileInfo';
import NDFLPage from '../NDFLPage/NDFLPage';
import NDFLWidget from '../NDFLWidget/NDFLWidget';

const Profile = () => {
  const [active, setActive] = useState(0);
  const [showWidget, setShowWidget] = useState<boolean>(false);
  const user = useAppSelector(state => state.auth.user);

  const hashes: any = {
    '#history': 1,
    '#ndfl': 2,
  };

  const {changeActiveTab, getActiveTabFromHash} = useTabsWithHash(hashes, 'profile');

  const acceptStatus = 2;
  const waitStatus = 1;
  const rejectStatus = 3;
  const tabBar = [
    {name: 'Личные данные', child: <ProfileInfo />},
    {name: 'История активаций', child: <ActivationHistory />},
    {
      name: 'Анкета НДФЛ',
      child: (
        user?.tax && (user?.tax.status === waitStatus
          || user?.tax.status === acceptStatus
          || user?.tax.status === rejectStatus))
      && !showWidget
        ? <NDFLPage
          onClick={() => {setShowWidget(true);}}
        />
        : <NDFLWidget />,
      hidden: !user?.tax
    },
  ];

  const handleTabChange = (index: number) => {
    setActive(index);
    changeActiveTab(index);
  };

  useEffect(() => {
    setActive(getActiveTabFromHash());
  }, [getActiveTabFromHash]);

  return (
    <div>
      <Title>Личный кабинет</Title>
      <InnerTabs changeActiveTab={handleTabChange} id={'profile'} tabs={tabBar} activeTab={active}/>
    </div>
  );
};

export default Profile;
